/**
 * created by lei lei on 2020/5/12
 * 扩展树组件 系统角色里面的菜单权限
 * [{
 key: 2,
 name: 'Joe Black',id:'9',
 age: 32,
 address: 'Sidney No. 1 Lake Park',
 check:false,//第一列主键值必须放到最前面
 edit:false,
 publish:false,
 revert:false,
 delete:false,
 children:[]
 }]
 titleKeyList={[{key:'check',titleName:'名称'},{key:'edit',titleName:'编辑'},{key:'publish',titleName:'发布'},{key:'revert',titleName:'撤稿'},{key:'delete',titleName:'删除'}]} //五个状态值对应表头的名称

 checkId={'id'}//对应上面的标识字段独一无二
 childrenColumnName  数据源的子节点键值，如果不传子节点键值默认是children
 逻辑很复杂，全部是递归写的，修改时候慎重在慎重，读懂了在修改
 isRequired 必传属性

 */
import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {Tree, Table, Checkbox, Empty} from "antd";
import {uuid} from '../../../utils/index'
import './exTrecss.css'

const {TreeNode} = Tree;
let hasTrue = false
let hasFalse = false
let index = 0
export default class ExtendedTree extends Component {
    static defaultProps = {
        defaultExpandAllRows: false,//默认是false，关闭展开项的
        childrenColumnName: 'children',//默认属性是children，如果没有那数据源的子键值请给children必须有//子键值
    }
    static propTypes = {
        dataSource: PropTypes.array.isRequired, //数据源
        titleKeyList: PropTypes.array.isRequired,//表头部titleName ，和每一列对应的check键的字段名，其对应的key值必须是状态值true和false
        checkId: PropTypes.string.isRequired,//数据源标识独特的id,不可重复
        firstColumnsName: PropTypes.string.isRequired,//第一列按钮后文字显示标识
        selectAllData: PropTypes.func.isRequired,//点击确定函数
        defaultExpandAllRows: PropTypes.bool,//是否展开所有的树
        childrenColumnName: PropTypes.string,//数据源的默认子节点的key为children。
        exceptFirstBtnKey: PropTypes.string,//字符串键值，根据这个值判断除第一列之外的右侧按钮是否可以展示默认是可以展示，传了该字段，以该字段对应的bool值为准，true展示，false 不展示
    }

    constructor(props) {
        super(props);
        this.state = {
            dataSource: [],
            isFirst: true,
        }
    }

    componentWillMount() {
    }

    componentDidMount() {
        if (this.state.isFirst) {
            //解决页面调用组件数据异步，组件渲染相关的问题。
            this.state.dataSource = this.props.dataSource
            this.addKey(this.state.dataSource)
            this.state.isFirst = false
            this.setState({})
        }

    }

    componentWillReceiveProps(newProps) {
        this.state.dataSource = newProps.dataSource
        this.addKey(this.state.dataSource)
        this.setState({})
    }


    render() {
        //  console.log(this.props.titleKeyList)
        if (this.state.isFirst) {
            this.state.dataSource = this.props.dataSource
            //给数据增加表格渲染的key。
            this.addKey(this.state.dataSource)
            this.state.isFirst = false
        }
        //console.log(this.state.dataSource)
        let columns = [];//表格列集合
        let firstColumnsName = this.props.firstColumnsName//第一列显示名称的键
        //循环生成表格列，根据调用组件传入的值去动态生成表格列
        this.props.titleKeyList.map((item, index) => {
            if (index === 0) {
                columns.push(
                    {
                        title: item.titleName,
                        dataIndex: item.key,
                        key: item.key,
                        width: '40%',
                        render: (text, record, index) => {
                            let pointKey = item.key
                            // console.log(text, record,index)
                            let indeterminate = false
                            /* if(record[item.key]){
                                 indeterminate=false
                             }else{
                                hasTrue=false
                                  hasFalse=false
                                //this.checkIndeterminate(record.children,pointKey)
                             }
                             // 定义一个状态，只要子集有true ,父级肯定半选或全选
                            // 第一个状态为true 只能确定全选或者半选 ;
                             //如果子集有一个false 确定只是半选。
                             console.log(hasTrue,hasFalse)
                             if(hasTrue&&hasFalse){
                                 indeterminate=true
                             }*/
                            //半选不支持


                            return (
                                <div style={{/*float: "right"*/}}>
                                    <Checkbox style={{paddingRight: 5}} checked={record[item.key]} indeterminate={indeterminate} onChange={() => {
                                        this.itemBtnClick(record, pointKey)
                                    }}/>{record[firstColumnsName]}

                                </div>


                            )
                        }

                    }
                )
            } else {
                columns.push(
                    {
                        title: item.titleName,
                        dataIndex: item.key,
                        key: item.key,
                        width: 50 / (this.props.titleKeyList.length - 1) + '%',
                        render: (text, record) => {
                            let pointKey = item.key
                            let firstKey = this.props.titleKeyList[0].key
                            if (this.props.exceptFirstBtnKey) {
                                let btnKey = this.props.exceptFirstBtnKey
                                if (record[btnKey]) {
                                    return (
                                        <Checkbox disabled={!record[firstKey]} checked={record[item.key]}
                                                  onChange={() => {
                                                      this.itemBtnClick(record, pointKey)
                                                  }}/>
                                    )
                                } else {
                                    return (
                                        <div></div>
                                    )

                                }

                            } else {
                                return (
                                    <Checkbox disabled={!record[firstKey]} checked={record[item.key]} onChange={() => {
                                        this.itemBtnClick(record, pointKey)
                                    }}/>
                                )
                            }

                        }

                    }
                )
            }


        })

        return (
            <div className={'treeTable'}>
                <Table columns={columns} defaultExpandAllRows={this.props.defaultExpandAllRows}
                       childrenColumnName={this.props.childrenColumnName} dataSource={this.state.dataSource}
                       pagination={false}/>
                <style>{` 
                    .treeTable .ant-table-placeholder{border-bottom: 0;}
                    .treeTable .ant-table .ant-table-row-indent + .ant-table-row-expand-icon{margin-top: 2px;}
                `}</style>
            </div>
        )
    }

    itemBtnClick(record, key) {
        this.checkCurrent(this.state.dataSource, record, key)
        // console.log('当前更改后的数据源',this.state.dataSource,'当前操作数据',record,'当前标识',key)
        this.props.selectAllData && this.props.selectAllData(this.state.dataSource)
        //从第一条数据开始找，=如果第二层权为false ,父级去掉选中
        this.secondStatusRelationParent();
        this.setState({})
    }

    //取消二级，一级不关联
    secondStatusRelationParent(){
        let childKey = this.props.childrenColumnName;
        this.state.dataSource.forEach((Item,Index)=>{
            let num = 0;
            if(Item[childKey] && Item[childKey].length) {
                Item[childKey].forEach((item, index) => {
                    if(!item.show){
                        num++;
                    }
                })
                if(num === Item[childKey].length){
                    this.state.dataSource[Index].show = false;
                    this.state.dataSource[Index].edit = false;
                    this.state.dataSource[Index].publish = false;
                    this.state.dataSource[Index].revert = false;
                    this.state.dataSource[Index].delete = false;
                }
            }
        })
    }

    //递归当前操作的这一条数据给与相应的状态
    checkCurrent(dataSource, record, key) {
        let checkId = this.props.checkId
        // console.log(checkId,dataSource, record, key)
        let childKey = this.props.childrenColumnName/*?this.props.childrenColumnName:'children'*/
        dataSource.forEach((item) => {
            if (record[checkId] === item[checkId]) {
                // item[key]=true
                //当前数据选中
                item[key] = !item[key]
                //当前数据的第一列为false 未选中的时候，第一列对应的后几列属性值全部为false
                let titleKeyList = this.props.titleKeyList
                if (titleKeyList[0].key === key) {
                    //如果当前第一列操作的状态为false，子集每一项全部为false
                    if (!item[key]) {
                        titleKeyList.forEach((itemKey) => {
                            let keyItem = itemKey.key
                            item[keyItem] = false
                        })
                    }
                }

                //当前集是父级，去递归当前集的
                this.currentIsParent(item, key)
                //当前集获取父级 this.state.dataSource初始数据源 dataSource当前同级的子集 item 当前操作数据 key 当前列标识
                //递归父级状态沟通后目前不要了
                // this.sonGetPrent(this.state.dataSource, dataSource, item, key)
            } else {
                if (item[childKey] && item[childKey].length > 0) {
                    //如果没找到，继续递归去下一层找
                    this.checkCurrent(item[childKey], record, key)

                }
            }

        })

    }

    //递归，父节点选中，子节点全部选中，父节点取消，子节点全部取消
    currentIsParent(currentData, key) {
        let checkId = this.props.checkId
        let titleKeyList = this.props.titleKeyList
        //当前点击后按钮的状态
        let currentIsParentStatus = currentData[key]
        let childKey = this.props.childrenColumnName/*?this.props.childrenColumnName:'children'*/
        //console.log('当前数据',currentData,'当前数据按钮标识',key,'当前按钮状态',currentIsParentStatus)
        currentData[childKey] && currentData[childKey].forEach((item, index) => {
            //item[key] = currentIsParentStatus
            //如果当前行第一列数据是false,那么当前行的数据都不可选。不可改变状态。
            //当前操作的不是第一列数据
            let firstKey = titleKeyList[0].key
            if (key !== firstKey) {
                if (item[firstKey]) {
                    item[key] = currentIsParentStatus
                }
            } else {
                item[key] = currentIsParentStatus
            }


            //如果当前父级选为false 当前父级，子集所有的都为false
            if (!currentIsParentStatus) {
                if (titleKeyList[0].key === key) {
                    //如果当前第一列操作的状态为false，后几列属性都为false
                    if (!item[key]) {
                        titleKeyList.forEach((itemKey) => {
                            let keyItem = itemKey.key
                            item[keyItem] = false
                        })
                    }
                }
            }


            //当前子数据继续递归。保持子节点状态跟父节点一致
            this.currentIsParent(item, key)
        })

    }

    //子集寻找父级，如果当前子集同级子全选中，父级选中，如果子取消选中，父级取消选中
    sonGetPrent(dataSource, peerOnSource, currentData, key) {
        //当前数据源集合 this.state,dataSource
        //console.log('当前数据源',this.state.dataSource,'当前同级数据数组',peerOnSource,'当前点击数据',currentData)

        let checkId = this.props.checkId
        let childKey = this.props.childrenColumnName/*?this.props.childrenColumnName:'children'*/
        if (dataSource[childKey]) {
            //不是第一层
            dataSource[childKey].forEach((item) => {
                //如果子集有一项相等，证明当前dataSource 是父级 //如果不是继续去寻找
                if (item[checkId] === currentData[checkId]) {
                    //  console.log('当前数据源父级',dataSource,peerOnSource)
                    let peerOnSourceLength = peerOnSource.length  //子集数据长度
                    let num = 0 //子集数据为true的个数
                    peerOnSource.forEach((itemSon) => {
                        if (itemSon[key]) {
                            num++
                        }
                    })
                    //  console.log(num,peerOnSourceLength)
                    if (num === peerOnSourceLength) {
                        //说明子集全为true,父级为true
                        dataSource[key] = true
                    } else {
                        //说明子集不全为true，当前操作数据的父级为false
                        dataSource[key] = false

                        //如果当前父级选为false 当前父级，子集所有的都为false
                        let titleKeyList = this.props.titleKeyList
                        if (titleKeyList[0].key === key) {
                            //如果当前第一列操作的状态为false，子集全部为false
                            if (!item[key]) {
                                titleKeyList.forEach((itemKey) => {
                                    let keyItem = itemKey.key
                                    dataSource[keyItem] = false
                                })
                            }
                        }


                    }
                    //无论当前集为选中还是为选中，还要继续去寻找他的父级，给父级递归状态，dataSource当前数据
                    this.getPrent(this.state.dataSource, dataSource, key)

                } else {
                    //继续新递归
                    this.sonGetPrent(item, peerOnSource, currentData, key)
                }
            })
        } else {
            if (dataSource.length > 0) {
                dataSource.forEach((item) => {

                    if (item[checkId] === currentData[checkId]) {
                        //console.log('当前点击层是第一层不需要处理')
                    } else {
                        //递归继续执行
                        this.sonGetPrent(item, peerOnSource, currentData, key)
                    }
                })
            }

        }

    }

    //父级寻找父级 数据源，当前数据，标识key
    getPrent(dataSource, record, key) {
        let checkId = this.props.checkId
        let childKey = this.props.childrenColumnName/*?this.props.childrenColumnName:'children'*/
        dataSource.forEach((item) => {
            if (record[checkId] === item[checkId]) {
                // item[key]=true
                // item[key]= !item[key]
                //当前子节点全部选中
                //  this.currentIsParent(item,key)
                //当前集获取父级  dataSource当前同级的子集
                //找到父级，去处理父级状态
                //数据源，当前数据同级数据，当前数据，标识key
                this.sonGetPrent(this.state.dataSource, dataSource, item, key)
            } else {
                if (item[childKey] && item[childKey].length > 0) {

                    this.getPrent(item[childKey], record, key)

                }
            }

        })

    }

    //半选状态check 递归以实现，但是表格组件不支持不支持
    checkIndeterminate(data, pointKey) {
        let childKey = this.props.childrenColumnName/*?this.props.childrenColumnName:'children'*/
        if (data && data.length > 0) {
            data.forEach((item) => {
                if (item[pointKey]) {
                    hasTrue = true
                } else {
                    hasFalse = true
                }
                this.checkIndeterminate(item[childKey], pointKey)

            })
        }
    }

    //给数据增加默认的key.所有数据就不用传key，是为了解决tab的key警告的问题。
    addKey(data) {
        if (data && data.length > 0) {
            data.forEach((item) => {
                index++
                item.key = index

                //这个值是取得组件传入的子节点的键值。
                let childKey = this.props.childrenColumnName/*?this.props.childrenColumnName:'children'*/
                if (item[childKey] && item[childKey].length < 1) {
                    item[childKey] = null
                }
                // item.key=uuid()
                this.addKey(item[childKey])

            })
        }
    }

}